import { render } from "./ClientCheckList.vue?vue&type=template&id=64fa4401&scoped=true"
import script from "./ClientCheckList.vue?vue&type=script&lang=js"
export * from "./ClientCheckList.vue?vue&type=script&lang=js"

import "./ClientCheckList.vue?vue&type=style&index=0&id=64fa4401&scoped=true&lang=css"
import "./ClientCheckList.vue?vue&type=style&index=1&id=64fa4401&lang=scss&scoped=true"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fa4401"]])

export default __exports__